import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_CIVILBUDGETSCHEDULE,
  DELETE_CIVILBUDGETSCHEDULE,
  UPDATE_CIVILBUDGETSCHEDULE,
  ADD_NEW_CIVILBUDGETSCHEDULE,
} from "./actionType";

import {
  getCivilBudgetScheduleSuccess,
  getCivilBudgetScheduleFail,
  deleteCivilBudgetScheduleSuccess,
  deleteCivilBudgetScheduleFail,
  updateCivilBudgetScheduleSuccess,
  updateCivilBudgetScheduleFail,
  addCivilBudgetScheduleSuccess,
  addCivilBudgetScheduleFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getCivilBudgetScheduleApi,
  updateCivilBudgetScheduleApi,
  deleteCivilBudgetScheduleApi,
  addNewCivilBudgetScheduleApi,
  approveCivilBudgetScheduleApi
} from "../../helpers/backend_helper";

function* getCivilBudgetSchedule({ payload: civilBudgetSchedule }) {
  try {
    const response = yield call(getCivilBudgetScheduleApi, civilBudgetSchedule);
    yield put(getCivilBudgetScheduleSuccess(GET_CIVILBUDGETSCHEDULE, response.data));
  } catch (error) {
    yield put(getCivilBudgetScheduleFail(GET_CIVILBUDGETSCHEDULE, error));
  }
}

function* onUpdateCivilBudgetSchedule({ payload: civilBudgetSchedule }) {
  try {
    if (civilBudgetSchedule.setApprove) {
      const response = yield call(approveCivilBudgetScheduleApi, civilBudgetSchedule);
      yield put(updateCivilBudgetScheduleSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateCivilBudgetScheduleApi, civilBudgetSchedule);
      yield put(updateCivilBudgetScheduleSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateCivilBudgetScheduleFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCivilBudgetSchedule({ payload: civilBudgetSchedule }) {
  try {
    const response = yield call(deleteCivilBudgetScheduleApi, civilBudgetSchedule);
    yield put(deleteCivilBudgetScheduleSuccess({ civilBudgetSchedule, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCivilBudgetScheduleFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCivilBudgetSchedule({ payload: civilBudgetSchedule }) {
  try {
    const response = yield call(addNewCivilBudgetScheduleApi, civilBudgetSchedule);
    yield put(addCivilBudgetScheduleSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCivilBudgetScheduleFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetCivilBudgetSchedule() {
  yield takeEvery(GET_CIVILBUDGETSCHEDULE, getCivilBudgetSchedule);
}

export function* watchUpdateCivilBudgetSchedule() {
  yield takeEvery(UPDATE_CIVILBUDGETSCHEDULE, onUpdateCivilBudgetSchedule);
}

export function* watchDeleteCivilBudgetSchedule() {
  yield takeEvery(DELETE_CIVILBUDGETSCHEDULE, onDeleteCivilBudgetSchedule);
}

export function* watchAddNewCivilBudgetSchedule() {
  yield takeEvery(ADD_NEW_CIVILBUDGETSCHEDULE, onAddNewCivilBudgetSchedule);
}

function* civilBudgetScheduleSaga() {
  yield all([
    fork(watchGetCivilBudgetSchedule),
    fork(watchDeleteCivilBudgetSchedule),
    fork(watchUpdateCivilBudgetSchedule),
    fork(watchAddNewCivilBudgetSchedule)
  ]);
}

export default civilBudgetScheduleSaga;
